/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Ismerkedés, Csevegés, Randik",
      "Hibás mobilszám.",
      "Get the app",
      "Folytatás az Apple-lel",
      "Folytatás Facebook használatával",
      "Folytatás Google használatával",
      "Bejelentkezés",
      "Regisztráció",
      "A folytatáshoz írd be az alább megjelenített karaktereket a beviteli mezőbe.",
      "Tovább",
      "Add meg a karaktereket",
      "Biztonsági ellenőrzés",
      "Újratöltés",
      "Hozz létre egy olyan új jelszót, amire könnyen emlékezni fogsz",
      "Frissítés",
      "Jelszó megerősítése",
      "A jelszó minimális hossza {{num}} [[characters:num]]",
      "Jelszó",
      "Új jelszó létrehozása",
      "Badoo – Blog",
      "Karrier",
      "Csevegés",
      "Városok",
      "Cookie-k kezelése",
      "Copyright © 2006 – jelen. Bumble. Minden jog fenntartva.",
      "Az Apple márkanév és az Apple logó az Apple Inc. védjegyei.{{__EOL__}}A Google Play a Google LLC védjegye.",
      "Letöltés",
      "Facebook",
      "Kövess bennünket",
      "Súgó",
      "Instagram",
      "Nyelv",
      "LinkedIn",
      "Áttekintés",
      "A Badoo a Bumble Inc. része",
      "Adatvédelmi szabályzat",
      "Safety Centre",
      "Webhelytérkép",
      "Modernkori rabszolgaság elleni törvény – nyilatkozat",
      "Felhasználási feltételek",
      "Twitter",
      "Add meg alább az e-mail-címedet vagy mobilszámodat, és elküldjük neked az új jelszó létrehozására vonatkozó utasításokat.",
      "Új jelszó kérése",
      "Add meg az e-mail-címedet vagy a telefonszámodat",
      "Elfelejtett jelszó",
      "A megjelenített modellek csak illusztrációk",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Nem kell várnod egy kapcsolatra.{{__EOL__}}{{__EOL__}}Vesd be magad egy kicsit mélyebb csevegésbe, és kezdd rögtön a jó részével. Tudod, amikor igazán megismeritek egymást.",
      "Készen állsz most a csevegésre?",
      "A regisztrációval elfogadod a <a class=\"link\" href=\"{{terms_url}}\">Felhasználási feltételeinket</a>. Az <a class=\"link\" href=\"{{privacy_url}}\">Adatvédelmi szabályzatunkból</a> megtudhatod, hogyan kezeljük az adataidat.",
      "Segítünk többet megmutatni a valódi egyéniségedből, <br />hogy még nagyobb élmény legyen a randizás.",
      "Ismerkedj magabiztosan.",
      "vagy",
      "Már rendelkezel fiókkal?",
      "Regisztrálj az e-mail-címeddel vagy a telefonszámoddal",
      "Szerezd meg a randizással azt, amire vágysz.{{__EOL__}}Nem kell magyarázkodnod.",
      "Csak csevegni szeretnél? Rendben.{{__EOL__}}Készen állsz megállapodni? Szuper.{{__EOL__}}{{__EOL__}}Ha pedig meggondolnád magad, erre bármikor lehetőséged van.",
      "Randizni",
      "Komoly kapcsolat céljából",
      "Csevegni",
      "Találkozz olyanokkal, akik ugyanazt keresik, mint Te.",
      "{{name}}, {{age}}",
      "A biztonságod elsődleges fontosságú számunkra.",
      "Keresd fel a Safety Centre-t – a tudásközpontunkat, ahol minden támogatást megtalálsz ahhoz, hogy magabiztosan randizhass.",
      "Keresd fel a Safety Centre-t",
      "Az első a biztonság.<br/>Mindig.",
      "Az első pillanattól kezdve azt gondoltam, hogy működni fog…",
      "Először semmi komolyat nem kerestem…",
      "Ha egy tanácsot adhatnék mindenkinek a Badoo appon, az az lenne, hogy legyenek önmaguk...",
      "Badoo sikertörténetek",
      "Ismerd meg a többi sikertörténetet",
      "{{num}}__CUT__Értékelés",
      "Apple App Store",
      "Bízz bennünk! Sok-sok milliónyi embert hoztunk össze 2006 óta.",
      "{{num}} M+__CUT__letöltés",
      "{{num}} M+",
      "Google Play Store",
      "Értjük a dolgunkat.",
      "Jelentkezz be az e-mail-címeddel vagy a telefonszámoddal",
      "Add meg a jelszavadat",
      "Elfelejtetted a jelszavadat?",
      "Regisztráció",
      "Nem rendelkezel fiókkal?",
      "Bejelentkezés",
      "Regisztráció"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "karakter",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters",
                  "characters"
            ],
            "singular": [
                  "karakter",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character",
                  "character"
            ]
      },
      "day": {
            "plural": [
                  "nap",
                  "napja",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap"
            ],
            "singular": [
                  "nap",
                  "napja",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap",
                  "nap"
            ]
      },
      "hour": {
            "plural": [
                  "óra",
                  "órája",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra"
            ],
            "singular": [
                  "óra",
                  "órája",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra",
                  "óra"
            ]
      },
      "minute": {
            "plural": [
                  "perc",
                  "perce",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc"
            ],
            "singular": [
                  "perc",
                  "perce",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc",
                  "perc"
            ]
      },
      "month": {
            "plural": [
                  "hónap",
                  "hónapja",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap"
            ],
            "singular": [
                  "hónap",
                  "hónapja",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap",
                  "hónap"
            ]
      },
      "second": {
            "plural": [
                  "másodperc",
                  "másodperce",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc"
            ],
            "singular": [
                  "másodperc",
                  "másodperce",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc",
                  "másodperc"
            ]
      },
      "year": {
            "plural": [
                  "év",
                  "éve",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év"
            ],
            "singular": [
                  "év",
                  "éve",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év",
                  "év"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
